import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

// import MainImage from "../../assets/images/mainStage/Home_audi_accesorios_banner_escritorio.jpg";
// import MainImageMovil from "../../assets/images/mainStage/Home_audi_accesorios_banner_movil.jpg";
// import MainImageTablet from "../../assets/images/mainStage/Home_audi_accesorios_banner_tablet_ios@2x.png";

const MainStage = () => {
  return (
    <>
      <div className="row mainstage">
        <div className="mainstage__image col-12">
          <LazyLoadImage
            alt="imageMain"
            src={
              process.env.REACT_APP_IMAGE_PATH +
              "/stage/Home_banner_escritorio.jpg"
            }
            className="d-none d-lg-block"
          />
          <LazyLoadImage
            alt="imageMainMovil"
            src={
              process.env.REACT_APP_IMAGE_PATH + "/stage/Home_banner_tablet.png"
            }
            className="d-none d-sm-block d-lg-none"
          />
          <LazyLoadImage
            alt="imageMainMovil"
            src={
              process.env.REACT_APP_IMAGE_PATH + "/stage/Home_banner_movil.jpg"
            }
            className="d-block d-sm-none"
          />
        </div>
        <div className="mainstage__description">
          <span>
            Accesorios <br />
            Originales Audi
          </span>
          <button
            className="btn btn-outline-white btn-singleline"
            onClick={() =>
              window.open(
                "https://www.appsaudi.com.mx/catalogo_audi_accesorios/new.html",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Catálogo digital
          </button>
        </div>
      </div>
    </>
  );
};

export default MainStage;
